export default __webpack_public_path__ + "static/media/Animals_08.51ab366e.png";